export const getLastHumanMessageContentRenderVersion = (
	lastHumanMessageContent: unknown,
): string | null | undefined => {
	if (lastHumanMessageContent === undefined) {
		return undefined;
	}

	if (typeof lastHumanMessageContent === 'string') {
		return lastHumanMessageContent;
	}

	try {
		return JSON.stringify(lastHumanMessageContent);
	} catch {
		return null;
	}
};
